module.exports = __webpack_public_path__ + "static/media/landingPageLogo.a6f75f76.svg";